import { render, staticRenderFns } from "./SuppleTerms.vue?vue&type=template&id=59333a1d&"
import script from "./SuppleTerms.vue?vue&type=script&lang=js&"
export * from "./SuppleTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports